<template>
  <div class="certificates-list-view">
    <title-component :size="1">
      <translate>Certificates list</translate>
    </title-component>
    <table-component-buefy-many-searches
      v-if="mixin.loaded"
      :content="certificates"
      :headings="headings"
      :filters="mixin.filters"
      :save_search=true
      :save_filters=true
      :saved_filters="savedFilters"
      :item_keys="item_keys"
      :display_spec="certificateSpecs"
      :total_items="mixin.total_items"
      :pagination_callback="mixin.loadItems"
      class="veridens-dashboard">
    </table-component-buefy-many-searches>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableComponentBuefyManySearches from '@/components/layout/table/TableComponentBuefyManySearches'
  import { certificateSpecs } from '@/display_context/display_context'
  import { errorHandler, loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import { queryToFiltersPublic } from '@/utility/utility_functions'
  import { extractErrorMessages } from '@/utility/errorMessages'
  import Status from '@/classes/http/Status'

  function isRejectedSearch (err) {
    return Boolean(err.response) &&
      err.response.status === Status.BAD_REQUEST
  }

  export default {
    name: 'certificate-list-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Certificate No.', 'Customer', 'County', 'Certification', 'Qualification', 'Issued date', 'Expiry date '],
        item_keys: ['publicCertificateNumberCell', 'holder', 'customer.county', 'service.name', 'qualification.value', 'issueDate', 'expiryDate'],
        certificateSpecs: certificateSpecs,
        mixin: { actionMethod: this.getCertificatesUniqueCertNumber }
      }
    },
    components: {
      TitleComponent,
      TableComponentBuefyManySearches
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      }),
      savedFilters () {
        return queryToFiltersPublic(this.$route.query)
      }
    },
    methods: {
      ...mapActions([
        'getCertificatesUniqueCertNumber'
      ]),
      handleError (err) {
        if (isRejectedSearch(err)) {
          // The filters come from the URL, so a hand edited or stale link
          // sends values the backend refuses. The visitor sees why;
          // Sentry does not need to.
          extractErrorMessages(err.response.data)
            .forEach(text => this.errorMessage(text))
          return
        }
        errorHandler.methods.handleError.call(this, err)
      }
    }
  }
</script>
